import { useContext } from 'react';

import { ExamCenterContext } from './exam-center-provider';

function useExamCenter() {
  const context = useContext(ExamCenterContext);

  if (!context) {
    throw new Error('useExamCenter must be used within a ExamCenterProvider');
  }

  return context;
}

export { useExamCenter };
